/**
 * 指定された日付が新着（現在の日付から指定された日数以内）かどうかを判定します。
 * @param {string} date - チェックする日付（'YYYY.MM.DD'形式）
 * @param {number} days - 新着と見なす日数
 * @return {boolean} 新着であればtrue、そうでなければfalse
 */
export const isLatestNews = (date: string, days = 14): boolean => {
  const currentDate = new Date();
  const [year, month, day] = date.split('.').map(Number);
  const inputDate = new Date(year, month - 1, day);
  const differenceInDays = (currentDate.getTime() - inputDate.getTime()) / (1000 * 60 * 60 * 24);

  return differenceInDays <= days;
};
